<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template v-slot:left_view>
            <PmCounterManagementLeftTree ref="PmCounterManagementLeftTree" @transferSelectedCounterTreeNodeInfo="transferSelectedCounterTreeNodeInfo"></PmCounterManagementLeftTree>
        </template>
        <template v-slot:right_view>
            <PmCounterManagementRightList :counterTreeNode="counterTreeNode"></PmCounterManagementRightList>
        </template>
    </BasicLayout>
</template>

<script>
    import BasicLayout from '../../../layouts/BasicLayout';
    import PmCounterManagementLeftTree from "../../../components/pmConfig/pproject/PmCounterManagementForP/Left/PmCounterManagementLeftTree";
    import PmCounterManagementRightList from "../../../components/pmConfig/pproject/PmCounterManagementForP/Right/PmCounterManagementRightList";

    export default {
        name: 'PmCounterManagement',
        components: {
            BasicLayout,
            PmCounterManagementLeftTree,
            PmCounterManagementRightList,
        },
        data() {
            return {
                left: {
                    show: true,
                    name: `${this.$t('Pm.indicatorAndThreshold')}`
                },
                middle: {
                    show: false,
                    name: ''
                },
                right: {
                    show: true,
                    crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.indicatorAndThreshold')}`
                },
                counterTreeNode: {}
            };
        },
        methods: {
            transferSelectedCounterTreeNodeInfo(counterTreeNode){
                this.counterTreeNode = counterTreeNode;
            }
        }
    };
</script>

<style scoped>

</style>
